export enum MessageUpdateStatus {
  DELIVERY_ACK = "DELIVERY_ACK",
  READ = "READ",
  SERVER_ACK = "SERVER_ACK",
}
